





























































































































































































import { Component, Vue } from 'vue-property-decorator';
import { CANCEL_ORDER, ORDER_NEW_DATA_MANDATORY_SUPPLIER_FIELDS } from '@/queries/Order';
import InvoiceNewButton from '../Invoice/InvoiceNewButton.vue';
import OrderStatus from './OrderStatus.vue';
import { GQL_ordersSearch_orders } from '@/queries/__generated__/ordersSearch';
import PermissionService from '@/utils/permission-service';
import gql from 'graphql-tag';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_orderNewDataMandatorySupplierFields, GQL_orderNewDataMandatorySupplierFields_currentUser_currentUnit } from '@/queries/__generated__/orderNewDataMandatorySupplierFields';
import { get } from 'lodash';
import { KeysArray } from '@/utils/utils';

const ORDERS_SEARCH = gql`
  query ordersSearch(
    $limit: Int,
    $offset: Int,
    $orderBy: String,
    $orderDirection: String,
    $filters: OrderFilter
  ) {
    orders(
      limit: $limit,
      offset: $offset,
      orderBy: $orderBy,
      orderDirection: $orderDirection,
      filters: $filters
    ){
      id
      number
      date
      status
      isOpen
      isLocked
      isCancelled
      payableAmount
      currencyCode
      note
      export
      customer {
        id
      }
      invoice {
        id
        number
      }
      customerParty {
        id
        name
        unofficialName
      }
      supplierParty {
        id
        vatRegulation
      }
      isLocked
    }
  }
`;

@Component({
  components: {
    InvoiceNewButton,
    OrderStatus,
  },
})
export default class OrderList extends Vue {
  @SmartQuery<OrderList, GQL_orderNewDataMandatorySupplierFields>({
    query: ORDER_NEW_DATA_MANDATORY_SUPPLIER_FIELDS,
    fetchPolicy: "no-cache",
    update(data) {
      const  requiredCompanyFields: KeysArray<GQL_orderNewDataMandatorySupplierFields_currentUser_currentUnit> = [
        'email',
        'address',
        'zip',
        'city',
      ];
      const currentUnit = data.currentUser?.currentUnit;
      return requiredCompanyFields.filter(key => {
        const value = currentUnit ? get(currentUnit, key) : null;
        return !(typeof value === 'string' && value.trim().length);
      });
    },
  }) public missingCompanyFields?: GQL_orderNewDataMandatorySupplierFields;

  private ORDERS_SEARCH = ORDERS_SEARCH;
  private PermissionService = PermissionService;
  private selectedOrders: GQL_ordersSearch_orders[] = [];

  private cancelOrder(orderId: number) {
    this.$apollo.mutate({
      mutation: CANCEL_ORDER,
      variables: { orderId },
    }).then(() => {
      this.$sMessage.success(this.$t('Order.cancelSuccess'));
    });
  }
}
